<div class="col-12" style="padding: 5px 0 10px 0;text-align: center;background-color: #313131;">
    <label style="font-size: 8pt;font-weight: 300;color: #FFFFFF;font-family: Roboto;">
        © 2023. Powered by <label (click)="goToEcomm('https://dmmgroup.id')" style="cursor: pointer;">PT Digital Consumer Engagement. (v{{version}})</label>
    </label>
</div>